// Cashier Debit & Credit Transactions State

export default {
  debitCreditList: [],
  debitCreditInfo: {}
}
